import { TrackingDashboard } from 'rentalui-maps';
import { client } from '../api';
export default function Tracking() {
  return <section><h3>Maps and live tracking</h3><p>Track your active cab or delivery assignments. Open listing maps for facility and property directions.</p><TrackingDashboard client={client} vertical="jewelry" apiKey={process.env.REACT_APP_GOOGLE_MAPS_BROWSER_KEY} mapId={process.env.REACT_APP_GOOGLE_MAPS_MAP_ID} /></section>;
}
